import Image from 'next/image';
import { Text } from '@/components';
import LocationSvg from '../../../../public/images/global/locationSvg.svg';

interface LocationLoaderProps {
  show: boolean;
}

const LocationLoader: React.FC<LocationLoaderProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/95'>
      <div className='flex flex-col items-center justify-center gap-3'>
        <Image src={LocationSvg} alt='Location' width={96} height={96} />
        <Text className='text-center text-xl font-semibold text-white'>
          Finding your location,
          <br />
          please wait...
        </Text>
      </div>
    </div>
  );
};

export default LocationLoader;
